import { useIntl } from 'react-intl';

import type { AegStatusCount } from '../../../../api/aegOccurrences';
import { doneStages, openStages } from '../../config';
import { AEG_STAGE_BY_STATUS, type AegStatusEnum, type StageKey } from '../../types';
import Progress from '../Progress';

type BigNumberProps = {
    counts: AegStatusCount;
    total: number;
    selected: StageKey | null;
    onSelect: (stage: StageKey) => void;
};

const toStageCounts = (counts: AegStatusCount): Record<StageKey, number> =>
    Object.fromEntries(
        (Object.keys(counts) as AegStatusEnum[]).map(status => [AEG_STAGE_BY_STATUS[status], counts[status]])
    ) as Record<StageKey, number>;

export default function BigNumber({ counts, total, selected, onSelect }: BigNumberProps) {
    const intl = useIntl();
    const stageCounts = toStageCounts(counts);

    return (
        <div className='aeg-page-tiles'>
            <Progress
                counts={stageCounts}
                onSelect={onSelect}
                selected={selected}
                stageKeys={openStages}
                title={intl.formatMessage({ id: 'intl-msg:support.aeg.progress.inProgress' })}
                total={total}
            />
            <Progress
                counts={stageCounts}
                onSelect={onSelect}
                selected={selected}
                stageKeys={doneStages}
                title={intl.formatMessage({ id: 'intl-msg:support.aeg.progress.finished' })}
                total={total}
            />
        </div>
    );
}
